import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerWrapper: {
      '& $headerContent': {
        paddingBottom: 100,
        [theme.breakpoints.up('md')]: {
          paddingBottom: 200,
        },
      },

    },
    headerImgWrapper: {
      '&::before': {
        content: '""',
        display: 'block',
        width: '100%',
        height: 80,
        position: 'absolute',
        top: 0,
        left: 0,
        background: 'linear-gradient(180deg, #1B1925 0%, rgba(45, 50, 56, 0.0001) 100%)',
        zIndex: 1,
        [theme.breakpoints.up('md')]: {
          height: 120,
        },
      },
    },
    headerContent: {},
    results: {
      flex: '1',
    },
    expertCardWrapper: {
      '& .ais-Hits-list': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        flex: 1,
        listStyleType: 'none',
        paddingLeft: 0,
        marginTop: 0,
        '@media only screen and (min-width: 300px)': {
          flexDirection: 'row',
          flexWrap: 'wrap',
          justifyContent: 'flex-start',
          marginRight: `-${SMALL_MARGIN}px`,
        },
      },
      '& .ais-Hits-item': {
        width: 220,
        marginBottom: SMALL_MARGIN,
        '& img': {
          transition: 'height .3s ease',
        },
        '&:hover img': {
          height: '120%',
        },
        '@media only screen and (min-width: 300px)': {
          marginRight: SMALL_MARGIN,
          width: `calc((100% - ${2 * SMALL_MARGIN}px) / 2)`,
        },
        '@media only screen and (min-width: 600px)': {
          width: `calc((100% - ${3 * SMALL_MARGIN}px) / 3)`,
        },
        [theme.breakpoints.up('md')]: {
          width: `calc((100% - ${4 * SMALL_MARGIN}px) / 4)`,
        },
      },
    },
    expertCard: {
      width: '100%',
    },
    bodyWrapper: {
      display: 'flex',
      flexDirection: 'column',
      [theme.breakpoints.up('xl')]: {
        flexDirection: 'row',
      },
      '& $expertsSearchWrapper': {
        width: '100%',
        paddingBottom: '0',
        borderBottom: 'unset',
        [theme.breakpoints.up('xl')]: {
          width: 300,
          marginRight: MIDDLE_MARGIN,
          borderBottom: `1px solid ${colorsPalette.violetAnalyticsCard}`,
        },
      },
    },
    expertsSearchWrapper: {},
  }),
);

export default useStyles;
